export default __webpack_public_path__ + "static/media/oracle.8ec28b06.svg";